$(function(){
    $("#filterList").on("keyup", function() {
        var value = $(this).val().toLowerCase();
        var target = $(this).data('target');

        $(target).filter(function() {
            $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
        });

        if ($(this).val() === "" && target === '.project-list-item') {
            $('.project-list-item-inactive').hide();
        }
    });
});


// WEBPACK FOOTER //
// ./resources/js/components/filterlist.js